import React from 'react';
import clsx from 'clsx';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../index';
import { Alert } from '@material-ui/lab';
import { Collapse } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  success: {
    backgroundColor: '#00875E',
  },
  error: {},
  notification: {
    backgroundColor: '#ffffff',
    color: '#000',
  },
  icon: {
    fontSize: 20,
  },
  icone: {
    fontSize: '18px',
    marginRight: '8px',
    color: '#e45b5b',
    fontWeight: '600',
  },
  title: {
    marginBottom: '6px',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.9em',
  },
  closeButton: {
    alignSelf: 'flex-start',
  },
  limit: {
    [theme.breakpoints.down('xs')]: {
      width: '80%',
    },
  },
  positionBottom: {
    [theme.breakpoints.down('xs')]: {
      bottom: '68px',
      width: '85%',
      display: 'block',
      margin: 'auto',
    },
  },
  positionTop: {
    [theme.breakpoints.down('xs')]: {
      top: '68px',
      width: '85%',
      display: 'block',
      margin: 'auto',
    },
  },
  button: {
    textAlign: 'end',
  },
  buttonText: {
    color: '#1351B4',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));

function Message(props) {
  const classes = useStyles();
  let {
    variant,
    vertical = 'bottom',
    open,
    handleClose,
    title,
    text,
    buttonText,
    action,
  } = props;
  if (variant === 'error' || variant === 'success') {
    return (
      <MuiThemeProvider theme={theme}>
        <Snackbar
          anchorOrigin={{
            vertical: vertical,
            horizontal: isWidthUp('sm', props.width) ? 'left' : 'center',
          }}
          open={open}
          onClose={handleClose}
          classes={{
            anchorOriginBottomCenter:
              vertical === 'bottom'
                ? classes.positionBottom
                : classes.positionTop,
          }}
          style={{ zIndex: 9999 }}
        >
          <SnackbarContent
            className={clsx(classes[variant])}
            classes={{ message: classes.limit, action: classes.closeButton }}
            message={
              <React.Fragment>
                <div onClick={action}>
                  <div className={classes.title}>
                    {title && <strong>{title}</strong>}
                  </div>
                  <span className={classes.message}>
                    {variant === 'error' && (
                      <i className={'fas fa-times-circle ' + classes.icone} />
                    )}
                    {variant === 'success' && (
                      <i
                        className={'fas fa-check-circle ' + classes.icone}
                        style={{ color: '#fff' }}
                      />
                    )}
                    {variant === 'info' && (
                      <i
                        className={'fas fa-info-circle ' + classes.icone}
                        style={{ color: '#fff' }}
                      />
                    )}
                    {text}
                  </span>
                  {buttonText && (
                    <div className={classes.button}>
                      <span className={classes.buttonText}>{buttonText}</span>
                    </div>
                  )}
                </div>
              </React.Fragment>
            }
            action={[
              <IconButton
                key="close"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon className={classes.icon} />
              </IconButton>,
            ]}
          />
        </Snackbar>
      </MuiThemeProvider>
    );
  } else {
    return (
      <MuiThemeProvider theme={theme}>
        <Collapse in={open}>
          <Alert
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleClose}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            severity="info"
          >
            {title && <strong>{title} </strong>}
            {text}
          </Alert>
        </Collapse>
      </MuiThemeProvider>
    );
  }
}

export default withWidth()(Message);
